export default __webpack_public_path__ + "static/media/project2.0fe3810c.png";